<template>
  <v-row justify="center">
    <v-dialog
      v-model="showModal"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Nueva Agenda detectada
        </v-card-title>
        <v-card-text>Es necesario recargar para continuar.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="reload()"
          >
            Recargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { CHECK_DIARY_DATE } from '@/store/actions/user'

export default {
  name: 'ColumnWrapper',
  data: () => ({
    showModal: false
  }),
  computed: {
    diaryDate () {
      return this.$store.state.user.diaryDate
    },
    enabled () {
      return this.diaryDate !== null
    }
  },
  created () {
    this.requestValidation()
    this.delayValidation()
  },
  methods: {
    reload: function () {
      window.location.reload()
    },
    delayValidation: function () {
      const temp = this.requestValidation
      const timing = 1000 * 60 * 15 // 15min = 1000*60*15
      setInterval(function () {
        temp()
      }, timing)
    },
    requestValidation: function () {
      console.log('########### requestValidation ############')
      if (!this.$store.getters.isAuthenticated) return false
      this.$store.dispatch(CHECK_DIARY_DATE).then(function (resp) {
        console.log({resp}, 'CHECK_DIARY_DATE')
        this.showModal = resp.changed
      }.bind(this)).catch(function (error) {
        console.log('Error in requestValidation')
        console.log({error})
        this.showModal = true
      }.bind(this))
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Elements/DiaryDateValidator.vue